var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextCartoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 236,
    viewBox: "0 0 180 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 207.9C40.3767 207.9 0 167.531 0 117.9C0 68.2691 40.3767 27.9 90 27.9C139.623 27.9 180 68.2767 180 117.9C180 167.523 139.623 207.9 90 207.9ZM90 33.0227C43.1991 33.0303 5.13032 71.0991 5.13032 117.9C5.13032 164.701 43.2067 202.77 90 202.77C136.793 202.77 174.87 164.693 174.87 117.9C174.87 71.1067 136.801 33.0303 90 33.0303V33.0227Z",
    fill: "#FA9D73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2 73.4C36.2 67.6667 40.4 64.8 48.8 64.8C52.4 64.8 59.2667 64.9333 69.4 65.2C80.6 65.7333 89.0667 66 94.8 66C99.4667 66 105.133 65.7333 111.8 65.2C116.333 64.9333 119.2 64.8 120.4 64.8C127.733 65.0667 133.933 66.4 139 68.8C140.467 69.4667 141.667 70.2667 142.6 71.2C143.533 72.1333 144 73.6667 144 75.8C144 78.7333 143.067 81.2667 141.2 83.4C139.333 85.4 137.067 86.4 134.4 86.4C131.467 86.4 127.2 86 121.6 85.2C116.667 84.2667 112.333 83.8 108.6 83.8C105 83.8 102.267 83.8667 100.4 84C100 88.4 99.8 98.9333 99.8 115.6C99.8 135.467 100.4 155.6 101.6 176L102 181.8C102 187.267 98.8667 190 92.6 190C87.6667 190 84.3333 188.867 82.6 186.6C80.8667 184.2 80 180.6 80 175.8C80 166.333 79.7333 154.533 79.2 140.4C78.6667 128.667 78.4 120.333 78.4 115.4C78.4 112.067 78.8 101.867 79.6 84.8L56.2 85C48.7333 85 43.5333 84.3333 40.6 83C37.6667 81.5333 36.2 78.3333 36.2 73.4Z",
    fill: "#FA9D73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextCartoon);
export default __webpack_public_path__ + "static/media/Text_Cartoon.b78d1e7e7065050d663381230ae02161.svg";
export { ForwardRef as ReactComponent };